import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Authority} from "../../admin/components/dictionary/region-education-authorities/dictionary-authority";

@Injectable()
export class CollegeRegionService {

  constructor(private http: HttpClient) { }

  getCollegeRegionInfo(){
    return this.http.get<Authority>(`api/s/colleges/region/info`);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/college-region.service.ts